import { Link } from 'wouter';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function Blog() {
  const posts = [
    {
      id: 'introducing-dakkio',
      title: 'Introducing dakkio.io: Time-Series Monitoring for Everyone',
      excerpt:
        'After years of wrestling with complex monitoring tools, we built something different. Meet dakkio—time-series monitoring you can control with plain English.',
      date: '2026-01-12',
      readTime: '5 min read',
      author: 'Malex Alexandru',
      category: 'Product',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-20 pb-16 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold text-slate-900 mb-6">Blog</h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Insights on time-series monitoring, natural language interfaces, and building
              better developer tools.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {posts.map((post) => (
              <article
                key={post.id}
                className="bg-white rounded-2xl border-2 border-slate-200 hover:border-primary-200 p-8 transition-all hover:shadow-lg"
              >
                <div className="flex items-center gap-4 mb-4">
                  <span className="px-3 py-1 bg-primary-50 text-primary-700 rounded-full text-sm font-semibold">
                    {post.category}
                  </span>
                  <div className="flex items-center text-sm text-slate-500">
                    <Calendar className="w-4 h-4 mr-1" />
                    {new Date(post.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </div>
                  <div className="flex items-center text-sm text-slate-500">
                    <Clock className="w-4 h-4 mr-1" />
                    {post.readTime}
                  </div>
                </div>

                <Link href={`/blog/${post.id}`}>
                  <a className="group">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4 group-hover:text-primary-600 transition-colors">
                      {post.title}
                    </h2>
                  </a>
                </Link>

                <p className="text-lg text-slate-600 mb-6 leading-relaxed">{post.excerpt}</p>

                <div className="flex items-center justify-between">
                  <div className="text-sm text-slate-600">
                    By <span className="font-semibold text-slate-900">{post.author}</span>
                  </div>
                  <Link href={`/blog/${post.id}`}>
                    <a className="inline-flex items-center text-primary-600 hover:text-primary-700 font-semibold transition-colors">
                      Read more
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </a>
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* Newsletter Signup */}
          <div className="mt-16 bg-gradient-to-br from-primary-600 to-secondary-500 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-4">
              Subscribe to Our Newsletter
            </h3>
            <p className="text-white/90 mb-6 max-w-2xl mx-auto">
              Get the latest updates on dakkio features, best practices for time-series
              monitoring, and developer tips delivered to your inbox.
            </p>
            <form className="max-w-md mx-auto flex gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-white"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-white text-primary-600 rounded-lg font-semibold hover:bg-slate-50 transition-colors whitespace-nowrap"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
